import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { authCheck } from "services/auth"
import {
  getAllReferralsAction,
  createReferralAction,
  getReferralDetailsAction,
  saveReferralCoverAction,
  updateReferralStatusAction,
  toggleReferralDrawerAction,
  setReferralFilterQueryAction,
} from "./actions"

const mapStateToProps = (state) => {
  const { referralDashboard } = state
  const isLogged = authCheck()
  return {
    isLogged,
    ...referralDashboard,
  }
}

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({
    getReferrals: getAllReferralsAction.request,
    createReferral: createReferralAction.request,
    getReferralDetails: getReferralDetailsAction.request,
    saveReferralCover: saveReferralCoverAction.request,
    updateReferralStatus: updateReferralStatusAction.request,
    toggleReferralDrawer: toggleReferralDrawerAction.call,
    setReferralFilterQueries: setReferralFilterQueryAction.call,
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)
